<template>
  <div class="Information">
    <!-- v-bind:style="{ minHeight: Height + 'px' }" -->
    <div class="msg_css">
      <div class="msg_left">
        <div class="left_tit">消息中心</div>
        <div class="left_tab_s">
          <el-tabs v-model="activeName" @tab-click="handleClick_">
            <el-tab-pane label="全部" name="unread"> </el-tab-pane>
            <el-tab-pane label="已读" name="read"> </el-tab-pane>
          </el-tabs>
        </div>
        <div class="left_list" @scroll="handleScroll">
          <div
            class="left_li"
            v-for="(item, index) in messageData"
            :key="index"
            :class="msg_id == item.id ? 'is_active_' : ''"
            @click="changeMsg(item, index)"
          >
            <div class="li_img">
              <img
                v-if="item.msg_type == 3"
                src="https://xcx.newacademic.net/video/home/msg_new.png"
                alt=""
              />
              <img
                v-else
                src="https://xcx.newacademic.net/video/home/msg_xitong.png"
                alt=""
              />
            </div>
            <div class="li_box">
              <div class="li_box_top">
                <div class="top_tit">
                  {{ item.msg_type == 3 ? "新功能上线通知" : "系统消息" }}
                  <span v-if="item.is_read == 1" style="color: #f1416c">●</span>
                </div>
                <div class="top_date">{{ item.create_time }}</div>
              </div>
              <div class="li_box_con">
                {{ item.msg_type == 3 ? item.desc : item.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="msg_right"
        :style="
          !msgData.id
            ? ' display: flex;justify-content: center;align-items: center;'
            : ''
        "
      >
        <div class="right_tit" v-if="msgData.id">
          {{ msgData.msg_type == 3 ? "新功能上线通知" : "系统消息" }}
        </div>
        <div class="right_con" v-if="msgData.id">
          <span
            style="white-space: pre-wrap; word-break: break-word"
            v-html="msgData.message"
          ></span>
        </div>
        <div class="no_msg" v-if="!msgData.id">
          <img
            style="width: 88px; height: 92px"
            src="../../../assets/imgs/user/msg_no.png"
            alt=""
          />
          <p style="color: var(---, #aaadb5)">点击消息查看详情内容</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  information,
  threeDay,
  fetchMessage,
  readMessage,
} from "@/Api/userMessage";
// import { parseTime } from "@/utils/date";
export default {
  data() {
    return {
      activeName: "unread",
      message: {},
      msg_id: null,
      messageData: [],
      messageList: [],
      messageList01: [],
      dialogVisible: false,
      newTitle: "",
      elements: "",
      days: [],
      con: "",
      activeNames: ["1"],
      Height: 0,
      queryForm: {
        page: 1,
        size: 10,
        isread: "",
      },
      msgData: {
        create_date: "",
        desc: "",
        id: null,
        is_read: null,
        message: "",
        msg_type: null,
        timestramp: null,
        title: "",
        user_id: null,
      },
      count_s: 0,
      no_count: 0,
      loading: false,
    };
  },
  created() {
    this.handleClick();
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是190
    // console.log(this.name)
    this.Height = document.documentElement.clientHeight - 120; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 120;
    };
  },
  methods: {
    handleScroll(e) {
      const target = e.target;
      // 滚动到底部
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.loading && this.count_s <= this.messageData.length) return; // 防止重复请求
      this.loading = true;
      this.queryForm.page += 1;
      this.handleClick();
    },
    handleClick_() {
      this.queryForm.page = 1;
      this.handleClick();
    },
    handleClick() {
      if (this.activeName == "unread") {
        this.queryForm.isread = "";
      } else {
        this.queryForm.isread = "2";
      }
      // console.log(tab.label);
      // console.log(this.activeName);
      this.messageList = [];
      this.messageList01 = [];
      fetchMessage(this.queryForm)
        .then((res) => {
          console.log(res);
          let record = 0;
          res.data.data.data.forEach((item) => {
            item.create_time = this.formatTimeDiff(item.create_date);
          });
          if (this.queryForm.page == 1) {
            this.msgData.id = null;
            this.messageData = res.data.data.data;
          } else {
            this.messageData = [...this.messageData, ...res.data.data.data];
          }
          this.count_s = res.data.data.count;
          this.loading = false;
          // console.log(record)
        })
        .catch((err) => {
          console.log(err);
        });
      // if (this.activeName == "unread" || this.activeName == "read") {
      //   if (this.activeName == "unread") {
      //     this.message = {
      //       page: 1,
      //       type: 1,
      //     };
      //   }
      //   if (this.activeName == "read") {
      //     this.message = {
      //       page: 1,
      //       type: 0,
      //     };
      //   }
      //   information(this.message)
      //     .then((res) => {
      //       // console.log(res);
      //       this.messageList = res.data.data.data;
      //       console.log();
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });

      // }

      // if (this.activeName == "three") {
      //   let ids = {
      //     id: "",
      //   };
      //   threeDay(ids)
      //     .then((res) => {
      //       console.log(res);
      //       this.days = res.data.data;
      //       // console.log();
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // }
    },
    formatTimeDiff(targetTime) {
      const targetDate = new Date(targetTime);
      const now = new Date();

      const diffMs = now - targetDate; // 时间差（毫秒）
      if (diffMs < 0) return "未来"; // 如果传入时间比当前晚

      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffDays > 3) {
        // 超过3天，显示日期
        const year = targetDate.getFullYear();
        const month = String(targetDate.getMonth() + 1).padStart(2, "0");
        const day = String(targetDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      } else if (diffDays >= 1) {
        return `${diffDays}天前`;
      } else if (diffHours >= 1) {
        return `${diffHours}小时前`;
      } else if (diffMinutes >= 1) {
        return `${diffMinutes}分钟前`;
      } else {
        return "刚刚";
      }
    },
    changeMsg(row, i) {
      this.msgData = row;
      this.msg_id = row.id;
      this.open(row, i);
    },
    open(it, i) {
      // console.log(it);

      if (it.is_read == 1) {
        let read_id = {
          msg_id: it.id.toString(),
        };
        readMessage(read_id)
          .then((res) => {
            this.messageData[i].is_read = 2;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    get_no_msg() {
      fetchMessage({
        page: 1,
        size: 10,
        isread: "1",
      })
        .then((res) => {
          console.log(res);

          this.no_count = res.data.data.count;
          // this.$emit("newTotal", this.no_count);
          eventBus.$emit("newTotal", this.no_count);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    three_open(it) {
      // console.log(it);

      this.dialogVisible = true;
      let ids = {
        id: it.id,
      };
      threeDay(ids)
        .then((res) => {
          // console.log(res);
          this.newTitle = res.data.data.title;
          this.elements = res.data.data.desc;
          this.con = res.data.data.con;
          // this.days = res.data.data;
          // console.log();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 打开折叠面板
    handleChange(i, val) {
      // console.log(i, val);
      // this.dialogVisible = true;
      let ids = {
        id: i.id,
      };
      threeDay(ids)
        .then((res) => {
          // console.log(res);
          this.newTitle = res.data.data.title;
          this.elements = res.data.data.desc;
          this.con = res.data.data.con;
          // this.days = res.data.data;
          // console.log();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.Information {
  display: flex;
  //
  width: 100%;
  // min-height: 912px;
  // padding: 28px 0;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  padding: 28px;
  background: var(--BgSecondary, #fff);
}
.msg_css {
  // max-width: 1148px;
  width: 100%;
  display: flex;
  // width: 1074px;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 12px;
  border: 1px solid var(--Border-1, #f1f1f2);
  background: var(--BgSecondary, #fff);

  .msg_left {
    display: flex;
    width: 442px;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    flex-shrink: 0;
    align-self: stretch;
    .left_tit {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 32px;
      align-self: stretch;

      color: var(--Gray-Gray-900, #181c32);

      font-family: "PingFang SC";
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px; /* 140% */
    }
  }
}
.left_list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  height: calc(100vh - 350px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.left_list::-webkit-scrollbar {
  width: 5px;
  height: 1px;
}
.left_list::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 5px;
  background-color: #c4c4c4;
}
.left_list::-webkit-scrollbar-track {
  //轨道部分
  // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ffffff;
  border-radius: 5px;
}
.left_tab_s {
  width: 100%;

  /deep/ .el-tabs__item.is-active {
    color: #181c32 !important;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #181c32 !important;
  }
  /deep/ .el-tabs__item:hover {
    color: #181c32 !important; /* 设置移入时的颜色 */
  }
}

.left_li {
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  cursor: pointer;
  .li_img img {
    width: 40px;
    height: 40px;
  }
  .li_box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
  }
  .li_box_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    .top_tit {
      display: flex;
      align-items: center;
      gap: 8px;

      color: var(--Gray-Gray-800, #3f4254);

      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
    }
    .top_date {
      color: var(--Gray-Gray-600, #7e8299);

      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }
  }
  .li_box_con {
    color: var(--Gray-Gray-600, #7e8299);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
  }
}
.left_li:hover {
  background: var(--Gray-Gray-100, #f9f9f9);
}
.is_active_ {
  background: var(--Gray-Gray-100, #f9f9f9);
}
.msg_right {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1 0 0;
  align-self: stretch;
  width: calc(100% - 442px);

  // border-radius: 12px;
  border: 1px solid var(--Border-1, #f1f1f2);
  background: var(--BgSecondary, #fff);
}
.right_tit {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  color: var(--Gray-Gray-900, #181c32);

  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 140% */
}
.right_con {
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Border-1, #f1f1f2);
  line-height: 22px;
}
.no_msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
</style>